export var AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
export var AUTH0_CLIENT_ID = process.env.AUTH0_CLIENT_ID;
export var AUTH0_AUDIENCE = process.env.AUTH0_AUDIENCE;